<template>
    <div class="IperMatrizPeligrosRegional">
        {{ regional }}
    </div>
</template>

<script>
export default {
    name: "IperMatrizPeligrosRegional",

    props: {
        regional: String
    }
}
</script>